/**
 * SignalR live home now parameters class
 * Hub: liveMatchesLive
 * Proxy: connectHome
 * Event: liveNowHome
 */
export default class LiveHubModel {
  /**
   * Class constructor method
   */
  constructor({ tenantID = APP_SETTINGS.tenant, culture = APP_SETTINGS.player.language, onlyShort = false }) {
    /**
     * Tenant ID
     * @type {number}
     */
    this.tenantID = tenantID;
    /**
     * Language iso
     * @type {number}
     */
    this.culture = culture;
    /**
     * Load multiple markets from signalR
     * @type {boolean}
     */
    this.onlyShort = onlyShort;
  }

  /**
   * Load parameters as array
   * @returns {*[]}
   */
  loadParams() {
    return [
      this.tenantID,
      this.culture,
      this.onlyShort,
    ];
  }
}
